import {createContext, useCallback, useContext, useReducer} from "react";
import {enablePatches, produce} from "immer";
import {debounce} from "@/helpers";

// enablePatches()

const initialState = {
    initialized: false,
    complete: false,
    inestimable: {},
    currentStep: 1,
    to: {},
    from: {},
    special: {},
    contact: {},
    requestId: null,
    branch: null,
    availabilities: null,
    estimate: null
}

const StateContext = createContext(initialState)
const UpdateContext = createContext(() => {})

export function StateProvider({children}) {


    const [state, setState] = useReducer((s, a) => produce(s, a), initialState)

    return (
        <UpdateContext value={setState}>
            <StateContext value={state}>
                {children}
            </StateContext>
        </UpdateContext>
    )
}

export function useAppState() {

    const state = useContext(StateContext)
    const setState = useContext(UpdateContext)

    return {state, setState}
}
